import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { AuthenticationClient, TokenPayload } from '../api-connector/sso-connector';
import { constant } from '../constants/constant';
import { AlertService } from './alert.service';
import jwtDecode from 'jwt-decode';
import { BehaviorSubject, Subject } from 'rxjs';
import { SignalRHubService } from './signalr-hub.service';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private listMenuConfig = new BehaviorSubject<any>([]);
  currentmMenuConfig = this.listMenuConfig.asObservable();
  constructor(
    private router: Router,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private signalRHub: SignalRHubService,
    private cacheService: CacheService,
    private authenticationClient: AuthenticationClient) { }

  alreadyLogin(): boolean {
    return this.getToken() != null;
  }
  getToken(): string | null {
    return localStorage.getItem(constant.LOCALSTORAGE_KEY);
  }
  setToken(token: string): void {
    localStorage.setItem(constant.LOCALSTORAGE_KEY, token);
  }
  getRefreshToken(): string | null {
    return localStorage.getItem(constant.REFRESH_TOKEN_KEY);
  }
  setRefreshToken(token: string): void {
    localStorage.setItem(constant.REFRESH_TOKEN_KEY, token);
  }
  getFirebaseToken(): string | null {
    return localStorage.getItem(constant.FIREBASE_TOKEN);
  }
  routingDashboard() {
    this.router.navigate(['/redirect']);
  }

  routingOrder() {
    this.router.navigate(['/sale']);
  }

  getAccount(): TokenPayload {
    const token = this.getToken();
    if (token) {
      try {
        const tokenPayLoad: TokenPayload = TokenPayload.fromJS(jwtDecode(token));

        // Initialize avatarId stream if not yet populated
        const currentVal = this.listMenuConfig.getValue();
        if (!currentVal || (Array.isArray(currentVal) && currentVal.length === 0)) {
          const savedId = localStorage.getItem(constant.AVATAR_ID);
          this.listMenuConfig.next(savedId || tokenPayLoad.avatarId);
        }

        return tokenPayLoad;
      } catch {
        this.alertService.error('Token đăng nhập không hợp lệ. Vui lòng đăng nhập lại');
        this.logoutClient();
      }
    }
    return undefined as any;
  }

  laQuanTriVien(): boolean {
    return this.getAccount().laQuanTriVien;
  }

  getAvatarId() {
    if (localStorage.getItem(constant.AVATAR_ID)) {
      return localStorage.getItem(constant.AVATAR_ID);
    }
    return this.getAccount()?.avatarId;
  }

  setAvatarId(id: string) {
    if (id) {
      localStorage.setItem(constant.AVATAR_ID, id);
      this.listMenuConfig.next(id);
    }
  }

  logout() {
    this.spinner.show();
    this.authenticationClient.logOut()
      .pipe(finalize(() => {
        this.logoutClient();
        this.spinner.hide();
      }))
      .subscribe({
        next: () => { },
        error: (err) => {
          console.error('Logout error caught locally to prevent infinite loop:', err);
        }
      });
  }
  private logoutClient(): void {
    this.signalRHub.stopConnection();
    this.cacheService.clear(); // Xóa toàn bộ cache (menu, permissions,...) để tránh dùng dữ liệu tài khoản cũ
    localStorage.clear();
    this.alertService.success('Tài khoản của bạn đã bị đăng xuất', 'Đăng xuất tài khoản');
    this.routingDashboard();
  }
}
